const img = require('./Left Hand Inswing.svg'); export default img;